window.addEventListener('DOMContentLoaded', () => {
  const gridContainerInner = document.querySelector('.js-highlighted-news-swiper-inner');

  if (gridContainerInner) {
    const handleSwiperClasses = (value) => {
      const gridContainer = document.querySelector('.js-highlighted-news-swiper-items');
      const gridContainerItems = document.querySelector(
        '.js-highlighted-news-swiper-items',
      ).children;

      if (value === 'add') {
        gridContainer.classList.add('swiper-wrapper');
        [].forEach.call(gridContainerItems, (item) => {
          item.classList.add('swiper-slide');
        });
      }

      if (value === 'remove') {
        gridContainer.classList.remove('swiper-wrapper');
        [].forEach.call(gridContainerItems, (item) => {
          item.classList.remove('swiper-slide');
        });
      }
    };

    function isSmallScreen() {
      const breakpointMediumDown = window.matchMedia('(max-width: 1025px)');
      return breakpointMediumDown.matches;
    }

    const activateSwiper = (swiperInstance) => {
      let swiper = swiperInstance.swiper;
      if (isSmallScreen()) {
        if (swiper == null) {
          handleSwiperClasses('add');
          const swiper = new Swiper(swiperInstance, {
            slidesPerView: 'auto',
            watchOverflow: true,
            pagination: {
              el: '.swiper-pagination',
              type: 'bullets',
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          });
        }
      } else {
        if (swiper != null) {
          handleSwiperClasses('remove');
          swiper.destroy();
        }
      }
    };

    activateSwiper(gridContainerInner);

    window.addEventListener('resize', () => {
      activateSwiper(gridContainerInner);
    });
  };
});
